export const MessageTypes = {
  ssoSuccess: 'ssoSuccess',
  ssoFail: 'ssoFail',
}

export const BROADCAST_CHANNEL_NAME = 'pollfish:sso';
export const OUTCOME_SUCCESS = 'success';
export const OUTCOME_FAIL = 'fail';